import React from 'react';
import { useChromeExtensionUTMQueryParamExtraction } from '../Samsung/utils';
import LoadingIndicator from '../Common/LoadingIndicator';
import styled from 'styled-components';

const StyledLoadingIndicator = styled(LoadingIndicator)`
  min-height: 100px;
`;

const ChromeDesktopUTMTracking: React.FC = () => {
  useChromeExtensionUTMQueryParamExtraction();

  return <StyledLoadingIndicator type="heart" />;
};

export default ChromeDesktopUTMTracking;
